import React, { useState, useEffect, useRef } from 'react';
import {
  Input,
  Checkbox,
  Select,
  Button,
  ConfigProvider,
  DatePicker,
  Slider,
  InputNumber,
  Tooltip,
} from 'antd';
import _ from 'lodash';
import { useFormDataContext } from '../../../contexts/form-data.ctx';
import Text from 'antd/lib/typography/Text';
import { Box } from '../../../../../components/Box';
import { VOTING_VALUES } from '../VotingInput';
import { countries, isoCountryCodes } from '../../../../editor/countries/countries';
import { Option } from '../../../../../components/Input';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import 'moment/locale/sk';
import sk_SK from 'antd/lib/locale/sk_SK';
import moment from 'moment';
import { dots } from '../../../../../utils/constants';
import AddressAutoCompleteInput from '../AddressAutocompleteInput';
import AddressAutoCompleteSeperatedInput from '../AddressAutocompleteSeperatedInput';
import { RenderSeparatedName, capitalizeFirstLetter, isNameValid } from '../../../../../utils/string';
import { TypInyIdentifikatorEnum, TypInyIdentifikatorEstablishmentTabsEnum } from '../../../../admin/pages/Interfaces';
import { translations } from '../../../../../utils/LocalizedStrings';
import { Icon } from 'semantic-ui-react';
import { COMPANY_LOOKUP_HOST } from '../../../../../constants';
import { Search } from 'semantic-ui-react';

const key = "spolocnici_establishment_single_person_custom"

function OwnersEstablishmentSinglePersonComponent({
  documentId,
  name,
  label = 'Select',
  singlePerson,
  ...rest
}) {
  const values = useFormDataContext(({ data, setField }) => ({
    value:
      data[name] === undefined || data[name] === ''
        ? { amount: 1, spolocnici: [{ address: { country: 'SK' }, separatedName: {} }] }
        : data[name],
    zakladneImanie:
      data['company.zakladneImanie'] === undefined ||
        data[name] === 'company.zakladneImanie'
        ? 0
        : data['company.zakladneImanie'],
    depositAdministrator: data['deposit_administrator_custom'],
    konatelia: data['konatelia_establishment_custom'] || { amount: 1, konatelia: [{ address: { country: "SK" } }] },
    setField,
  }));

  const [fieldValues, setFieldValues] = React.useState(values);
  const [zakladneImanie, setZakladneImanie] = useState(0);
  const [, updateState] = React.useState({});
  const forceUpdate = React.useCallback(() => updateState({}), []);

  const [searchString, setSearchString] = useState('');
  const [selectedCompany, setSelectedCompany] = useState({});
  const [personIndex, setPersonIndex] = useState();
  const [results, setResults] = useState([]);
  const promises = useRef();
  const [loading, setLoading] = useState(false);

  const handleChange = async () => {
    if (!fieldValues.value.baseInvestment || fieldValues.value.baseInvestment === "") {
      fieldValues.value.baseInvestment = 5000
      setZakladneImanie(5000)
    }
    let konatelia = values.konatelia
    let index = 0
    for (let konatel of values.konatelia.konatelia) {
      if (konatel.ownerIndex !== undefined) {
        if (fieldValues.value.spolocnici[konatel.ownerIndex]) {
          konatelia.konatelia[index] = { ownerIndex: konatel.ownerIndex, separatedName: fieldValues.value.spolocnici[konatel.ownerIndex].separatedName, idType: fieldValues.value.spolocnici[konatel.ownerIndex].idType, idNumber: fieldValues.value.spolocnici[konatel.ownerIndex].idNumber, address: fieldValues.value.spolocnici[konatel.ownerIndex].address, dateOfBirth: fieldValues.value.spolocnici[konatel.ownerIndex].dateOfBirth }
        }
        if (fieldValues.value.spolocnici[konatel.ownerIndex].type === "ownerCompany") {
          if (konatelia.konatelia.length > 1) {
            konatelia.konatelia.splice(index, 1)
          } else {
            konatelia.konatelia[0] = { address: { country: "SK" } }
          }
        }
      }
      index += 1
    }
    konatelia.amount = konatelia.konatelia.length
    konatelia.setFromOwners = true
    let amount = fieldValues.value.spolocnici.filter((spolocnik) => spolocnik.isForeignPerson).length
    await values.setField({
      target: {
        name,
        value: fieldValues.value,
      },
      konatelia: konatelia,
      foreign_owners_amount: { amount }
    });
  };

  const changeShare = (e) => {
    fieldValues.zakladneImanie = e.target.value;
    fieldValues.value[0].share = e.target.value;
    forceUpdate();
  };

  const changePerson = async (e, index) => {
    let valuesToSet = fieldValues;
    let persons = valuesToSet.value.spolocnici;
    let person = persons[index];
    person[e.target.name] = e.target.value ? e.target.value : e.target.checked;
    persons[index] = person;
    valuesToSet.value.spolocnici = persons;
    setFieldValues(valuesToSet);
    if (e.target.name === 'type') {
      person.idType = undefined
      if (e.target.value === 'ownerCompany') {
        person.representingPersons = [{}];
      } else {
        person.representingPersons = [];
      }
    }
    if (e.target.name === "isForeignPerson") {
      handleChange()
    }
    forceUpdate();
  };

  const changeSeparatedName = async (e, index) => {
    let valuesToSet = fieldValues;
    if (!fieldValues.value.spolocnici[index].separatedName) {
      fieldValues.value.spolocnici[index].separatedName = {}
    }
    let separatedName = fieldValues.value.spolocnici[index].separatedName;
    separatedName[e.target.name] = e.target.value ? e.target.value : e.target.checked;
    setFieldValues(valuesToSet);
    forceUpdate()
  }


  useEffect(() => {
    if (values.zakladneImanie && values.zakladneImanie !== zakladneImanie) {
      setZakladneImanie(values.zakladneImanie);
    }
  }, [values.zakladneImanie]);

  const changeRepresentingPerson = (e, index, representingPersonIndex) => {
    fieldValues.value.spolocnici[index].representingPersons[representingPersonIndex][
      e.target.name
    ] = e.target.value;
    forceUpdate();
  };

  const deleteRepresentingPerson = (index, representingPersonIndex) => {
    fieldValues.value.spolocnici[index].representingPersons.splice(
      representingPersonIndex,
      1,
    );
    forceUpdate();
    handleChange();
  };

  const addRepresentingPerson = (index) => {
    fieldValues.value.spolocnici[index].representingPersons.push({ separatedName: {} });
    forceUpdate();
    handleChange();
  };

  const handleChangeZakladneImanie = (newValue) => {
    fieldValues.value.baseInvestment = newValue;
    setZakladneImanie(newValue);
  };

  const changeDepositAdministrator = async (e, index) => {
    let depositAdministrator = values.depositAdministrator || { amount: 1, depositAdministrator: '', bank: { type: "ownerCompany", idType: "idNumber", country: "SK" }, representingPersons: [] }
    if (e.target.checked) {
      depositAdministrator.depositAdministrator = index
    } else {
      depositAdministrator.depositAdministrator = ''
    }
    depositAdministrator.setFromOwners = true
    await values.setField({
      target: {
        name: "deposit_administrator_custom",
        value: depositAdministrator
      }
    });
  };

  const changeKonatel = async (index) => {
    let konatelIndex
    let i = 0
    for (let konatel of values.konatelia.konatelia) {
      if (konatel.ownerIndex === index) {
        konatelIndex = i
        break
      }
      i += 1
    }
    let konatelia = values.konatelia
    if (konatelIndex !== undefined) {
      if (konatelia.konatelia.length > 1) {
        konatelia.konatelia.splice(konatelIndex, 1)
      } else {
        konatelia.konatelia[konatelIndex] = { address: { country: "SK" } }
      }
    } else {
      if (!konatelia.konatelia[0].edited && konatelia.konatelia[0].ownerIndex === undefined) {
        konatelia.konatelia[0] = { ownerIndex: index, separatedName: values.value.spolocnici[index].separatedName, idType: values.value.spolocnici[index].idType, idNumber: values.value.spolocnici[index].idNumber, address: values.value.spolocnici[index].address, dateOfBirth: values.value.spolocnici[index].dateOfBirth }
      } else {
        konatelia.konatelia.push({ ownerIndex: index, separatedName: values.value.spolocnici[index].separatedName, idType: values.value.spolocnici[index].idType, idNumber: values.value.spolocnici[index].idNumber, address: values.value.spolocnici[index].address, dateOfBirth: values.value.spolocnici[index].dateOfBirth })
      }
    }
    konatelia.amount = konatelia.konatelia.length
    konatelia.setFromOwners = true
    await values.setField({
      target: {
        name: 'konatelia_establishment_custom',
        value: konatelia
      }
    });
  }

  const isOwnerKonatel = (index) => {
    let result = false
    for (let konatel of values.konatelia.konatelia) {
      if (konatel.ownerIndex === index) {
        result = true
        break
      }
    }
    return result
  }

  const promiseCompanyLookup = (token, isCreateMode, type = '112') => {
    const controller = new AbortController();
    const signal = controller.signal;
    let cPromise = new Promise((resolve, reject) => {
      fetch(
        `${COMPANY_LOOKUP_HOST}/company/lookup-by-name${isCreateMode ? '-available' : ''
        }`,
        {
          body: JSON.stringify({ token, code: type }),
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
          },
          signal,
        },
      )
        .then((res) => res.json())
        .then((res) => {
          resolve(res.data);
        });
    });
    cPromise.cancel = () => controller.abort();
    return cPromise;
  };

  const handleSearchChange = async (e, data, isCreateMode) => {
    // setResults([]);
    // setFreeCompanyName([]);
    setLoading(true);
    // setNewCompanyName(data.value);
    setSelectedCompany({});
    promises.current = promises.current || [];
    promises.current.forEach((p) => p.cancel());
    promises.current = [];
    const responseData = promiseCompanyLookup(data.value, isCreateMode, '112');
    promises.current.push(responseData);
    responseData
      .then((responseData) => {
        if (responseData) {
          setResults(
            responseData.map((item) => ({
              title: item.fullNames.filter(n => moment(n.validFrom).isSameOrBefore(moment()) && !n.validTo)[0].value,
              description: `IČO: ${item.identifiers.filter(i => moment(i.validFrom).isSameOrBefore(moment()) && !i.validTo)[0].value}`,
              full_data: item,
            })),
          );
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const debounceHandleSearchChange = useRef(
    _.debounce(handleSearchChange, 500, {
      loading: true,
    }),
  );

  const onSearchChange = (e, data) => {
    setLoading(true);
    let newSearch = data.value;
    if (/^[0-9]+\s+$/.test(newSearch)) {
      newSearch = newSearch.replace(/\s/g, '');
    }

    setSearchString(newSearch);
    debounceHandleSearchChange.current(e, data, false);
  };

  useEffect(() => {
    if (selectedCompany.id) {
      let address = selectedCompany.addresses.filter(n => moment(n.validFrom).isSameOrBefore(moment()) && !n.validTo)[0]
      changePerson({
        target: {
          name: "address", value: {
            number: address.buildingNumber,
            street: address.street,
            zip: address.postalCodes[0],
            city: address.municipality.value,
            country: isoCountryCodes[address.country.code]
          }
        }
      }, personIndex)
      changePerson({ target: { name: 'name', value: selectedCompany.fullNames.filter(n => moment(n.validFrom).isSameOrBefore(moment()) && !n.validTo)[0].value } }, personIndex);
      changePerson({ target: { name: 'idType', value: "idNumber" } }, personIndex);
      changePerson({ target: { name: 'idNumber', value: selectedCompany.identifiers.filter(n => moment(n.validFrom).isSameOrBefore(moment()) && !n.validTo)[0].value } }, personIndex);
      setSearchString(selectedCompany.fullNames.filter(n => moment(n.validFrom).isSameOrBefore(moment()) && !n.validTo)[0].value)
      setPersonIndex(undefined)
      handleChange()
    }
  }, [selectedCompany])

  function addTextToElementNoResults() {
    const newDiv = document.createElement("div");
    newDiv.classList.add("noResultsMessage");
    const newContent = document.createTextNode(translations.artifacts.NewOwnerComponent.noResult);
    newDiv.appendChild(newContent);
    const el = document.querySelector('.search > div.results.transition.visible > div.empty.message')
    if (el) {
      el.appendChild(newDiv);
    }
  }

  useEffect(() => {
    addTextToElementNoResults()
    addTextToElementSearchingResults()
  }, [results]);

  function addTextToElementSearchingResults() {
    const newDiv = document.createElement("div");
    newDiv.classList.add("resultsParagraph");
    const newContent = document.createTextNode(translations.artifacts.NewOwnerComponent.specifySearchingName);
    newDiv.appendChild(newContent);
    const el = document.querySelector('.ui.search > .results')
    if (el) {
      el.appendChild(newDiv);
    }
  }

  return (
    <>
      <form id={'person'} className="fullGridRow">
        <span className="gridRow">
          <Box flex={1} style={{ position: 'relative' }}>
            <span style={{ position: 'absolute', top: 31, left: 8, zIndex: 2 }}>
              €
            </span>
            <Text strong>{translations.artifacts.EstablishmentSinglePerson.shareCapital}</Text>
            <InputNumber
              id={key + "_baseInvestment"}
              style={{ paddingLeft: 15 }}
              onFocus={(event) => event.target.select()}
              min={5000}
              type="number"
              name="share"
              onBlur={handleChange}
              onChange={handleChangeZakladneImanie}
              value={zakladneImanie}
              onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
            />
          </Box>
        </span>
      </form>
      {fieldValues &&
        fieldValues.value &&
        fieldValues.value.spolocnici &&
        fieldValues.value.spolocnici.map((person, index) => {
          return (
            <React.Fragment key={person.id}>
              <form id={'person' + index} className="fullGridRow ownerComponentEstablishmentSinglePerson">
                <span className="gridRow" style={{ marginTop: 10 }}>
                  <Box flex={1}>
                    <Text strong>{translations.artifacts.EstablishmentSinglePerson.choosePersonType}</Text>
                    <Select
                      id={key + index + "_personType"}
                      name="type"
                      onBlur={handleChange}
                      placeholder={translations.artifacts.EstablishmentSinglePerson.personType}
                      onChange={(value) => {
                        changePerson({ target: { name: 'type', value } }, index);
                      }}
                      value={person.type ? person.type : ''}>
                      <Option value="ownerPerson">{translations.artifacts.EstablishmentSinglePerson.individual}</Option>
                      <Option value="ownerCompany">{translations.artifacts.EstablishmentSinglePerson.legalPerson}</Option>
                    </Select>
                  </Box>
                </span>
                {person.type === 'ownerCompany' &&
                  <span className='newOwnerSearchContainer gridRow'>
                    <Box>
                      <Text strong>
                        {translations.artifacts.NewOwnerComponent.searchORSR}
                      </Text>
                      <Search
                        id="newOwnerSearch"
                        label={translations.artifacts.NewOwnerComponent.searchORSR}
                        name="name"
                        loading={loading}
                        onFocus={() => setPersonIndex(index)}
                        onBlur={() => setPersonIndex()}
                        onResultSelect={(e, data) => {
                          setPersonIndex(index)
                          setSelectedCompany(data.result.full_data);
                        }}
                        results={loading ? [] : results}
                        placeholder={translations.artifacts.NewOwnerComponent.searchWithNameOrICO}
                        size={'big'}
                        onSearchChange={onSearchChange}
                        value={searchString}
                      />
                    </Box>
                  </span>
                }
                <span className="gridRow" style={{ marginTop: 10 }}>
                  <Box flex={1}>
                    <p className='inputLabelTooltip'>
                      <Text strong>
                        {person.type === 'ownerCompany'
                          ? translations.artifacts.EstablishmentSinglePerson.enterBusinessName
                          : ''}
                      </Text>
                      <Tooltip title={translations.artifacts.EstablishmentSinglePerson.enterBusinessNameTooltip}>
                        <span className="icon-info">
                          <Icon name="info circle" />
                        </span>
                      </Tooltip>
                    </p>
                    {
                      person.type === 'ownerCompany'
                        ?
                        <Input
                          id={key + index + "_name"}
                          name="name"
                          onBlur={handleChange}
                          placeholder={translations.artifacts.EstablishmentSinglePerson.businessName}
                          onChange={(e) => changePerson(e, index)}
                          value={person.name ? person.name : ''}
                        />
                        :
                        <>
                          <div className="addressAuto">
                            <Box>
                              <p className='inputLabelTooltip'>
                                <h4>{translations.artifacts.EstablishmentSinglePerson.owner}</h4>
                                <div style={{ marginBottom: 20 }} className="icon-position">
                                  <Tooltip title={translations.artifacts.EstablishmentSinglePerson.enterTitleNameTooltip}>
                                    <span className="icon-info">
                                      <Icon name="info circle" />
                                    </span>
                                  </Tooltip>
                                </div>
                              </p>
                              <span className="gridRow" style={{ marginTop: 10 }}>
                                <Box flex={1}>
                                  <Text strong>
                                    {translations.artifacts.EstablishmentSinglePerson.titlesBefore}
                                  </Text>
                                  <Input
                                    id={key + index + "_titles_before"}
                                    name="titlesBefore"
                                    onBlur={handleChange}
                                    placeholder="Tituly pred menom"
                                    onChange={(e) => changeSeparatedName(e, index)}
                                    value={person.separatedName?.titlesBefore ? person.separatedName.titlesBefore : ''}
                                  />
                                </Box>
                                <Box flex={1}>
                                  <Text strong>
                                    {translations.artifacts.EstablishmentSinglePerson.titlesAfter}
                                  </Text>
                                  <Input
                                    id={key + index + "_titlesAfter"}
                                    name="titlesAfter"
                                    onBlur={handleChange}
                                    placeholder="Tituly za menom"
                                    onChange={(e) => changeSeparatedName(e, index)}
                                    value={person.separatedName?.titlesAfter ? person.separatedName.titlesAfter : ''}
                                  />
                                </Box>
                              </span>
                              <span className="gridRow" style={{ marginTop: 10 }}>
                                <Box flex={1}>
                                  <Text strong>
                                    {translations.artifacts.EstablishmentSinglePerson.firstName}
                                  </Text>
                                  <Input
                                    id={key + index + "_name"}
                                    name="name"
                                    onBlur={handleChange}
                                    placeholder="Meno"
                                    onChange={(e) => changeSeparatedName(e, index)}
                                    value={person.separatedName?.name ? person.separatedName.name : ''}
                                  />
                                </Box>
                                <Box flex={1}>
                                  <Text strong>
                                    {translations.artifacts.EstablishmentSinglePerson.lastName}
                                  </Text>
                                  <Input
                                    id={key + index + "_surname"}
                                    name="surname"
                                    onBlur={handleChange}
                                    placeholder="Priezvisko"
                                    onChange={(e) => changeSeparatedName(e, index)}
                                    value={person.separatedName?.surname ? person.separatedName.surname : ''}
                                  />
                                </Box>
                              </span>
                            </Box>
                          </div>
                        </>
                    }
                  </Box>
                </span>
                <span
                  className="gridRow"
                  style={{ marginTop: 20, alignItems: 'center' }}>
                  <Box className='checkboxContainer'>
                    <Checkbox
                      id={'person' + index}
                      name="isForeignPerson"
                      checked={person.isForeignPerson}
                      onChange={(e) => changePerson(e, index)}
                    />
                    <Text strong>
                      {translations.artifacts.EstablishmentSinglePerson.partnerForeginer}
                    </Text>
                  </Box>
                  <Box className='checkboxContainer'>
                    <Checkbox
                      id={'person' + index}
                      name="depositAdministrator"
                      checked={values.depositAdministrator && values.depositAdministrator.depositAdministrator === index}
                      onChange={(e) => changeDepositAdministrator(e, index)}
                      value={person.name ? person.name : ''}
                    />
                    <Text strong>
                      {translations.artifacts.EstablishmentSinglePerson.depositManager}
                    </Text>
                  </Box>
                  {person.type === "ownerPerson" &&
                    <Box className='checkboxContainer'>
                      <Checkbox
                        id={'person' + index}
                        name="konatel"
                        checked={isOwnerKonatel(index)}
                        onChange={(e) => changeKonatel(index)}
                        value={person.name ? person.name : ''}
                      />
                      <Text strong>
                        {translations.artifacts.EstablishmentSinglePerson.partnerExecutive}
                      </Text>
                    </Box>
                  }
                </span>
                <AddressAutoCompleteSeperatedInput
                  placeholder={person.type === 'ownerCompany'
                    ? translations.artifacts.EstablishmentSinglePerson.enterCompanyAdress
                    : translations.artifacts.EstablishmentSinglePerson.enterHomeLocation}
                  label={person.type === 'ownerCompany'
                    ? translations.artifacts.EstablishmentSinglePerson.enterCompanyAdress
                    : translations.artifacts.EstablishmentSinglePerson.enterHomeLocation}
                  tooltip={person.type === 'ownerCompany'
                    ? translations.artifacts.EstablishmentSinglePerson.enterCompanyAdressTooltip
                    : translations.artifacts.EstablishmentSinglePerson.enterHomeLocationTooltip}
                  id={key + index}
                  name="address"
                  onBlur={handleChange}
                  onChange={(value) => changePerson({ target: { name: "address", value: value.value } }, index)}
                  country={person.address.country}
                  number={person.address.number}
                  street={person.address.street}
                  zip={person.address.zip}
                  city={person.address.city}
                />
              </form>
              <form id={'person' + index} className="fullGridRow">
                <span
                  className="gridRow"
                  style={{ marginTop: 10, alignItems: 'end' }}>
                  <Box flex={1}>
                    <p className='inputLabelTooltip'>
                      <Text strong>{`${person.type === 'ownerCompany' ? translations.artifacts.EstablishmentSinglePerson.ownerHaveOtherId : translations.artifacts.EstablishmentSinglePerson.ownerHaveBirthId}`}</Text>
                      <Tooltip title={`${person.type === 'ownerCompany' ? translations.artifacts.EstablishmentSinglePerson.ICOTooltip : translations.artifacts.EstablishmentSinglePerson.birthIDTooltip}`}>
                        <span className="icon-info">
                          <Icon name="info circle" />
                        </span>
                      </Tooltip>
                    </p>
                    <Select
                      id={key + index + "_idType"}
                      name="idType"
                      onBlur={handleChange}
                      placeholder={`${person.type === 'ownerCompany' ? translations.artifacts.EstablishmentSinglePerson.ICO : translations.artifacts.EstablishmentSinglePerson.birthID
                        } ${translations.artifacts.EstablishmentSinglePerson.orID}`}
                      onChange={(value) => {
                        changePerson({ target: { name: 'idType', value } }, index);
                      }}
                      value={person.idType ? person.idType : undefined}>
                      {person.type === 'ownerCompany' ?
                        <>
                          <Option key={'idNumber'} value={'idNumber'}>
                            {"IČO"}
                          </Option>
                          <Option key={'otherId'} value={'otherId'}>
                            {'Identifikačný údaj'}
                          </Option>
                        </>
                        :
                        Object.entries(TypInyIdentifikatorEnum).map(([key, value]) => {
                          return (
                            <Option key={key} value={key}>{capitalizeFirstLetter(value)}</Option>
                          )
                        })
                      }
                    </Select>
                  </Box>
                  <Box flex={1}>
                    <p className='inputLabelTooltip'>
                      <Text strong>
                        {person.type === 'ownerCompany'
                          ? translations.artifacts.EstablishmentSinglePerson.enterICO
                          : translations.artifacts.EstablishmentSinglePerson.enterBirthID}
                      </Text>
                      <Tooltip title={`${person.type === 'ownerCompany' ? translations.artifacts.EstablishmentSinglePerson.enterICOTooltip : translations.artifacts.EstablishmentSinglePerson.enterBirthIDTooltip}`}>
                        <span className="icon-info">
                          <Icon name="info circle" />
                        </span>
                      </Tooltip>
                    </p>
                    <Input
                      id={key + index + "_idNumber"}
                      name="idNumber"
                      onBlur={handleChange}
                      placeholder={person.type === 'ownerCompany'
                        ? translations.artifacts.EstablishmentSinglePerson.enterICOPlaceholder
                        : translations.artifacts.EstablishmentSinglePerson.enterBirthIDPlaceholder
                      }
                      onChange={(e) => changePerson(e, index)}
                      value={person.idNumber ? person.idNumber : ''}
                    />
                  </Box>
                  {person.type !== 'ownerCompany' && (
                    <Box flex={1}>
                      <Text strong>Vyberte dátum narodenia</Text>
                      <ConfigProvider locale={sk_SK}>
                        <DatePicker
                          onBlur={handleChange}
                          onChange={(date, dateString) =>
                            changePerson(
                              {
                                target: {
                                  name: 'dateOfBirth',
                                  value: moment(date).format('DD.MM.YYYY'),
                                },
                              },
                              index,
                            )
                          }
                          name="dateOfBirth"
                          id={key + index + "_dateOfBirth"}
                          value={
                            person.dateOfBirth &&
                              person.dateOfBirth !== 'Invalid date'
                              ? moment(person.dateOfBirth, 'DD.MM.YYYY')
                              : undefined
                          }
                          placeholder={translations.artifacts.EstablishmentSinglePerson.birthDate}
                          format={'D.M.YYYY'}
                          size="large"
                          style={{
                            width: '100%',
                          }}
                        />
                      </ConfigProvider>
                    </Box>
                  )}
                </span>
              </form>
              {person.type === 'ownerCompany' && (
                <>
                  <form className="fullGridRow">
                    {person.representingPersons.map(
                      (representingPerson, representingPersonIndex) => {
                        return (
                          <div style={{ margin: '10px 0' }}>
                            <Box className="personHeaderTitle">
                              <Text strong>
                                {translations.artifacts.EstablishmentSinglePerson.representMan +
                                  (representingPersonIndex + 1)}
                              </Text>
                              <div className="personDivider"></div>
                            </Box>
                            <div className="gridRow" style={{ alignItems: 'end' }}>
                              <Box flex={0.6}>
                                <Text strong>{translations.artifacts.EstablishmentSinglePerson.enterFunc}</Text>
                                <Input
                                  id={key + '_repre_' + index + "_" + representingPersonIndex + "function"}
                                  name="function"
                                  onBlur={handleChange}
                                  placeholder={translations.artifacts.EstablishmentSinglePerson.func}
                                  onChange={(e) =>
                                    changeRepresentingPerson(
                                      e,
                                      index,
                                      representingPersonIndex,
                                    )
                                  }
                                  value={
                                    representingPerson.function
                                      ? representingPerson.function
                                      : ''
                                  }
                                />
                              </Box>
                              <Box flex={0.6}>
                                <Text strong>
                                  {translations.artifacts.EstablishmentSinglePerson.enterTitleName}
                                </Text>
                                <Input
                                  id={key + '_repre_' + index + "_" + representingPersonIndex + "name"}
                                  name="name"
                                  onBlur={handleChange}
                                  placeholder={translations.artifacts.EstablishmentSinglePerson.titleName}
                                  onChange={(e) =>
                                    changeRepresentingPerson(
                                      e,
                                      index,
                                      representingPersonIndex,
                                    )
                                  }
                                  value={
                                    representingPerson.name
                                      ? representingPerson.name
                                      : ''
                                  }
                                />
                              </Box>
                              <Button
                                onClick={() =>
                                  deleteRepresentingPerson(
                                    index,
                                    representingPersonIndex,
                                  )
                                }
                                disabled={person.representingPersons.length === 1}
                                type="primary"
                                className="removeButton">
                                <MinusOutlined />
                              </Button>
                            </div>
                          </div>
                        );
                      },
                    )}
                  </form>
                  <form className="fullGridRow">
                    <span className="gridRow" style={{ marginTop: 10 }}>
                      <Box
                        flex={1}
                        className="rwdWidth"
                        style={{ textAlign: 'center', marginTop: 20 }}>
                        <Button
                          onClick={() => addRepresentingPerson(index)}
                          type="primary"
                          className="addPersonButton">
                          <PlusOutlined />
                          {translations.artifacts.EstablishmentSinglePerson.addRepresent}
                        </Button>
                      </Box>
                    </span>
                  </form>
                </>
              )}
            </React.Fragment>
          );
        })}
    </>
  );
}

function OwnersEstablishmentSinglePersonHTMLRenderer(values) {
  let returnValue = '';
  if (
    values &&
    values['spolocnici_establishment_single_person_custom'] &&
    values['spolocnici_establishment_single_person_custom'].spolocnici &&
    Array.isArray(values['spolocnici_establishment_single_person_custom'].spolocnici)
  ) {
    for (let person of values['spolocnici_establishment_single_person_custom']
      .spolocnici) {
      const separatedName = RenderSeparatedName(person.separatedName);
      returnValue += `<b>${person.type === 'ownerCompany' ? 'Obchodné Meno' : 'Meno a priezvisko'
        }:</b>${person.type === 'ownerCompany' ? '&#9;&#9;&#9;&#9;&#9;' : '&#9;&#9;&#9;&#9;'}    ${person.type === 'ownerCompany'
          ? (person.name ? person.name : '[DOPLŇTE]')
          : (separatedName && separatedName !== '') ? separatedName : "[DOPLŇTE]"}<br>`;
      let addressTabLength =
        person.type === 'ownerCompany'
          ? '&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;'
          : '&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;';
      returnValue += `<b>${person.type === 'ownerCompany' ? 'sídlo' : 'bydlisko'
        }:</b>${person.type === 'ownerCompany' ? '&#9;' : ''}${addressTabLength}`
      returnValue += person.address.street ? person.address.street : "[Doplňte]"
      returnValue += " "
      returnValue += person.address.number ? person.address.number : "[Doplňte]"
      returnValue += ", "
      returnValue += person.address.zip ? person.address.zip : "[Doplňte]"
      returnValue += " "
      returnValue += person.address.city ? person.address.city : "[Doplňte]"
      returnValue += ", "
      returnValue += person.address.country ? countries.sk[person.address.country] : "[Doplňte]"
      returnValue += `<br>`;
      let dobTabLength =
        person.type === 'ownerCompany'
          ? person.idType === 'idNumber'
            ? '&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;'
            : '&#9;&#9;&#9;&#9;&#9;&#9;&#9;'
          : '&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;';
      returnValue += `<b>${person.type === 'ownerCompany'
        ? person.idType === 'idNumber'
          ? 'IČO'
          : 'identifikátor'
        : 'narodený'
        }:</b>${person.type === 'ownerCompany' ? '&#9;' : ''}${dobTabLength}${person.type === 'ownerPerson'
          ? person.dateOfBirth
            ? person.dateOfBirth
            : '[DOPLŇTE]'
          : person.idNumber
            ? person.idNumber
            : '[DOPLŇTE]'
        }`;
      if (person.type === 'ownerPerson') {
        let idTabLength = person.idType ? TypInyIdentifikatorEstablishmentTabsEnum[person.idType] : '&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;';
        returnValue += `<b><br>${person.idType ? TypInyIdentifikatorEnum[person.idType] : '[DOPLŇTE]'
          }:</b>${idTabLength}${person.idNumber ? person.idNumber : '[DOPLŇTE]'}`;
      }
      returnValue += '<br><br>';
    }
  }

  return returnValue === '' ? '[SPOLOCNIK]' : returnValue;
}

function OwnersEstablishmentValidator(values) {
  if (!values["spolocnici_establishment_single_person_custom"] ||
    !values['spolocnici_establishment_single_person_custom'].spolocnici ||
    values['spolocnici_establishment_single_person_custom'].spolocnici.length === 0 ||
    !values['spolocnici_establishment_single_person_custom'].baseInvestment ||
    values['spolocnici_establishment_single_person_custom'].baseInvestment === "") {
    return false
  }
  let result = values["spolocnici_establishment_single_person_custom"].spolocnici.map(s => {
    return (s.type === 'ownerPerson'
      && validateOwnerPerson(s)
      && true)
      || (s.type === 'ownerCompany'
        && validateOwnerCompany(s)
        && validateOwnerCompanyRepresentingPerson(s)
        && true)
  }).filter(b => !b);
  return !result || result.length === 0;
}

function validateOwnerPerson(s) {
  return isNameValid(s.separatedName)
    && validateAddress(s.address)
    && s.idType
    && s.idNumber
    && s.dateOfBirth
    && true;
}

function validateAddress(address) {
  if (!address || !address.street || !address.city || !address.zip || !address.country || !address.number) {
    return false
  }
  return true
}

function validateOwnerCompany(s) {
  return s.name
    && validateAddress(s.address)
    && s.idType
    && s.idNumber
    && true;
}

function validateOwnerCompanyRepresentingPerson(s) {
  let res = s.representingPersons.map(r => {
    return r.function
      && r.name
      && true;
  }).filter(rf => !rf);
  return !res || res.length === 0;
}

function SpolocniciEstablishmentFieldsValidator(values) {
  let invalidFields = []
  if (
    !values
    || !values[key]
    || !values[key].spolocnici
    || !Array.isArray(values[key].spolocnici)
  ) {
    return [key + "_baseInvestment", key + 0 + "_name", key + 0 + "_surname", key + 0 + "_idType", key + 0 + "_idNumber", key + 0 + "_dateOfBirth", key + 0 + "_street", key + 0 + "_city", key + 0 + "_number", key + 0 + "_zip", key + 0 + "_country", key + 0 + "_personType"];
  }
  if (!values[key].baseInvestment) {
    invalidFields.push(key + "_baseInvestment")
  }
  console.log(values[key].baseInvestment)
  let index = 0
  for (let spolocnik of values[key].spolocnici) {
    invalidFields = invalidFields.concat(validateSpolocnikFields(spolocnik, index))
    index += 1
  }
  return invalidFields
}

function validateSpolocnikFields(spolocnik, index) {
  let invalidFields = []
  if (!spolocnik.separatedName && (!spolocnik.type || spolocnik.type === "ownerPerson")) {
    invalidFields = invalidFields.concat([key + index + "_name", key + index + "_surname"])
  } else {
    if ((!spolocnik.type || spolocnik.type === "ownerPerson")) {
      if (!spolocnik.separatedName.name) {
        invalidFields.push(key + index + "_name")
      }
      if (!spolocnik.separatedName.surname) {
        invalidFields.push(key + index + "_surname")
      }
    }
  }
  if (!spolocnik.idType) {
    invalidFields.push(key + index + "_idType")
  }
  if (!spolocnik.idNumber) {
    invalidFields.push(key + index + "_idNumber")
  }
  if (!spolocnik.dateOfBirth) {
    invalidFields.push(key + index + "_dateOfBirth")
  }
  if (!spolocnik.address) {
    invalidFields = invalidFields.concat(key + index + "_street", key + index + "_city", key + index + "_number", key + index + "_zip", key + index + "_country")
  } else {
    if (!spolocnik.address.street) {
      invalidFields.push(key + index + "_street")
    }
    if (!spolocnik.address.number) {
      invalidFields.push(key + index + "_number")
    }
    if (!spolocnik.address.city) {
      invalidFields.push(key + index + "_city")
    }
    if (!spolocnik.address.zip) {
      invalidFields.push(key + index + "_zip")
    }
    if (!spolocnik.address.country) {
      invalidFields.push(key + index + "_country")
    }
  }
  if (!spolocnik.type) {
    invalidFields.push(key + index + "_personType")
  } else {
    if (spolocnik.type === "ownerCompany") {
      if (!spolocnik.name) {
        invalidFields.push(key + index + "_name")
      }
      if (spolocnik.representingPersons) {
        let representingPersonIndex = 0
        for (let representingPerson of spolocnik.representingPersons) {
          if (!representingPerson.function) {
            invalidFields.push(key + '_repre_' + index + "_" + representingPersonIndex + "name")
          }
          if (!representingPerson.name) {
            invalidFields.push(key + '_repre_' + index + "_" + representingPersonIndex + "function")
          }
          representingPersonIndex += 1
        }
      }
    }
  }
  return invalidFields
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  Mutator: OwnersEstablishmentSinglePersonComponent,
  HTMLRenderer: OwnersEstablishmentSinglePersonHTMLRenderer,
  Validator: OwnersEstablishmentValidator,
  FieldsValidator: SpolocniciEstablishmentFieldsValidator
};
